<template>
  <div
    :class="classes"
    v-click-outside.capture="onClickOutside"
    v-click-outside:mousedown.capture="onClickOutside"
    v-click-outside:touchstart.capture="onClickOutside"
  >
    <div
      @click="toggleMenu"
      class="k-select-selection"
      :tabindex="selectTabindex"
    >
      <input type="hidden" :name="name" :value="currentValue" />

      <span v-if="publicValue" class="k-select-selected-value">{{
        publicValue
      }}</span>
      <span v-else class="k-select-placeholder">请选择</span>
      <span class="k-select-arrow"> <k-icon type="caret-down"> </k-icon></span>
    </div>
    <transition name="transition-drop">
      <div v-show="visible" class="k-select-dropdown">
        <ul>
          <functional-options
            v-if="slotOptions"
            :options="selectOptions"
            :slot-update-hook="updateSlotOptions"
            :slot-options="slotOptions"
          ></functional-options>
          <li class="k-select-not-found" v-else><span>无匹配数据</span></li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
const prefixCls = "k-select";

import FunctionalOptions from "./functional-options.vue";

import { directive as clickOutside } from "v-click-outside-x";

export default {
  name: "k-select",
  components: { FunctionalOptions },
  directives: { clickOutside },
  props: {
    value: { type: [String, Number], default: "" },
    name: { type: String },
    disabled: { type: Boolean, default: false },
    circle: Boolean
  },
  computed: {
    classes() {
      return [
        `${prefixCls}`,
        {
          [`${prefixCls}-visible`]: this.visible,
          [`${prefixCls}-disabled`]: this.disabled,
          [`${prefixCls}-circle`]: this.circle
        }
      ];
    },
    selectTabindex() {
      return this.disabled ? -1 : 0;
    },
    selectOptions() {
      const selectOptions = [];
      const slotOptions = this.slotOptions || [];
      let optionCounter = -1;
      const currentIndex = this.focusIndex;

      for (let option of slotOptions) {
        optionCounter = optionCounter + 1;
        selectOptions.push(
          this.processOption(
            option,
            this.values,
            optionCounter === currentIndex
          )
        );
      }

      return selectOptions;
    }
  },
  data() {
    return {
      values: this.value,
      focusIndex: -1,
      prefixCls: prefixCls,
      currentValue: this.value,
      publicValue: "",
      visible: false, // 下拉内容是否显示
      slotOptions: this.$slots.default
    };
  },
  methods: {
    onOptionClick(option) {
      this.values = option.value;
      this.publicValue = option.label;
      this.hideMenu();
    },
    updateSlotOptions() {
      this.slotOptions = this.$slots.default;
    },
    processOption(option, value, isFocused) {
      if (!option.componentOptions) return option;
      const optionValue = option.componentOptions.propsData.value;
      const disabled = option.componentOptions.propsData.disabled;
      // console.log(value, optionValue);

      // const isSelected = value.includes(optionValue);
      const isSelected = value == optionValue;

      const propsData = {
        ...option.componentOptions.propsData,
        selected: isSelected,
        isFocused: isFocused,
        disabled: typeof disabled === "undefined" ? false : disabled !== false
      };

      return {
        ...option,
        componentOptions: {
          ...option.componentOptions,
          propsData: propsData
        }
      };
    },
    hideMenu() {
      this.toggleMenu(null, false);
    },
    toggleMenu(e, force) {
      if (this.disabled) {
        return false;
      }

      this.visible = typeof force !== "undefined" ? force : !this.visible;
    },
    setPublicValueByValue(value) {
      let publicValue = "";

      this.slotOptions.map(item => {
        if (item.componentOptions.propsData.value === value) {
          publicValue = item.componentOptions.children[0].text;
        }
      });

      this.publicValue = publicValue;
    },
    onClickOutside(event) {
      if (this.visible) {
        event.preventDefault();
        this.hideMenu();
      }
    }
  },
  mounted() {
    this.$on("on-select-selected", this.onOptionClick);

    if (this.selectOptions.length > 0) {
      this.setPublicValueByValue(this.value);
    }
  },
  watch: {
    value(value) {
      this.values = value;
      if (this.selectOptions.length > 0) {
        this.setPublicValueByValue(value);
      }
    },
    values(now, before) {
      if (now != before) {
        this.$emit("input", now);
        this.$emit("on-change", now);
      }
    }
  }
};
</script>
